<template>
<div class="card card-custom gutter-b card-stretch ">
    <div class="card-body">
        <div class="d-flex mb-8">
            <!--begin::Pic-->
            <div class="flex-shrink-0 mr-7">
                <div class="symbol symbol-50 symbol-lg-120">
                    <img alt="Pic" src="https://th.bing.com/th/id/OIP.MbPZ-r1B8OR2jBiUU8TylAHaE8">
                </div>
            </div>
            <!--end::Pic-->
            <!--begin: Info-->
            <div class="flex-grow-1">
                <!--begin::Title-->
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <!--begin::User-->
                    <div class="mr-3">
                        <div class="d-flex align-items-center mr-3">
                            <!--begin::Name-->
                            <a href="#" class="d-flex align-items-center text-dark text-hover-primary font-size-h2 font-weight-bolder mr-3">{{evento.name}}</a>
                            <!--end::Name-->

                        </div>
                        <!--begin::Contacts-->
                        <div class="d-flex flex-wrap my-2">
                            <div class="text-muted font-weight-bolder mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <!--begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/Communication/Mail-notification.svg-->
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"></rect>
                                            <path d="M21,12.0829584 C20.6747915,12.0283988 20.3407122,12 20,12 C16.6862915,12 14,14.6862915 14,18 C14,18.3407122 14.0283988,18.6747915 14.0829584,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,12.0829584 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z" fill="#000000"></path>
                                            <circle fill="#000000" opacity="0.3" cx="19.5" cy="17.5" r="2.5"></circle>
                                        </g>
                                    </svg>
                                    <!--end::Svg Icon-->
                                </span>{{participantes.length}} Registrados</div>
                            <div class="text-muted font-weight-bolder mr-lg-8 mr-5 mb-lg-0 mb-2">
                                <span class="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                                    <!--begin::Svg Icon | path:/metronic/theme/html/demo2/dist/assets/media/svg/icons/General/Lock.svg-->
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <mask fill="white">
                                                <use xlink:href="#path-1"></use>
                                            </mask>
                                            <g></g>
                                            <path d="M7,10 L7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 L17,10 L18,10 C19.1045695,10 20,10.8954305 20,12 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,12 C4,10.8954305 4.8954305,10 6,10 L7,10 Z M12,5 C10.3431458,5 9,6.34314575 9,8 L9,10 L15,10 L15,8 C15,6.34314575 13.6568542,5 12,5 Z" fill="#000000"></path>
                                        </g>
                                    </svg>
                                    <!--end::Svg Icon-->
                                </span>{{clubs.length}} Clubes registrados</div>
                            <div v-if="evento.register== '0'" class="bg-danger text-white border border-danger rounded px-4">
                                Inscripciones Finalizadas
                            </div>
                            <div v-else class="bg-success text-white border border-success rounded px-4">
                                Inscripciones habilitadas
                            </div>
                        </div>
                        <!--end::Contacts-->
                    </div>
                    <!--begin::User-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Title-->
                <!--begin::Content-->
                <div class="d-flex align-items-center flex-wrap justify-content-between">
                    <!--begin::Description-->
                    <div class="flex-grow-1 font-weight-bold text-dark-50 py-2 py-lg-2 mr-5">El siguiente evento tiene como finalizad destacar el deporte...</div>
                    <!--end::Description-->
                    <!--begin::Progress-->

                    <!--end::Progress-->
                </div>
                <!--end::Content-->
            </div>
            <!--end::Info-->
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Información" name="first">

                <div class="box">

                    <label ng-bind="'Event Description:' | translate" ng-if="eventDescription" class="ng-binding ng-scope" _msthash="6731296" _msttexthash="505817">Descripción del evento:</label><!-- end ngIf: eventDescription -->

                    <div>
                        <strong _msthash="6487156" _msttexthash="69095">
                            <span translate="" class="ng-scope" _istranslated="1">Lugar</span>:</strong><!-- ngIf: venueName -->
                        <p v-html="evento.location"></p>

                    </div>
                    <div>
                        <!-- ngIf: minimumAgeToRegister -->
                        <!-- ngRepeat: period in registrationPeriodList -->
                        <div ng-repeat-start="period in registrationPeriodList" class="ng-scope"><strong _msthash="7227740" _msttexthash="2063633"><span ng-bind="period.registrationPeriodName + ' Start Date' | translate" class="ng-binding" _istranslated="1">Fecha de Competencia</span>:</strong>
                            <p ng-bind="getDateAccordingToUserTimezone(period.startDateITS)" class="ng-binding" _msthash="7740083" _msttexthash="183313">{{$moment(evento.startdate).format('DD MMM')}}
                                        <span v-if="evento.startdate != evento.enddate"> - {{$moment(evento.enddate).format('DD MMM YYYY')}}</span></p>
                        </div>
                        <div v-if="evento.deadline" class="ng-scope"><strong _msthash="7227741" _msttexthash="2588820"><span ng-bind="period.registrationPeriodName + ' End Date' | translate" class="ng-binding" _istranslated="1">Fecha de cierre de inscripciones</span>:</strong>
                            <p ng-bind="getDateAccordingToUserTimezone(period.endDateITS)" class="ng-binding" _msthash="7740084" _msttexthash="170560">{{$moment(evento.deadline).format('DD MMM hh:mm A')}}</p>
                        </div><!-- end ngRepeat: period in registrationPeriodList -->

                    </div><!-- ngIf: eventFeesStructuresForRoles -->
                    <!-- ngIf: contactPersonName -->
                    <div data-ng-if="contactPersonName" class="ng-scope">
                        <font _mstmutation="1" _msthash="6487157" _msttexthash="369616"><strong translate="" class="ng-scope" _mstmutation="1">Persona de contacto</strong>:</font>
                        <p ng-bind="contactPersonName" class="ng-binding" _msthash="6973044" _msttexthash="173992">David Flores Payé</p>
                        <p>Tel: 959 977 620</p>
                        <p ng-bind="actualData.contactPersonPhoneNumber" class="ng-binding" _msthash="6973045" _msttexthash="430664">federaciontkdperu@gmail.com</p>
                    </div>

                </div>
                

            </el-tab-pane>
            <el-tab-pane label="Clubes" name="second">

                <el-table :data="clubs" border style="width: 100%">
                    <!--<el-table-column label="N°" width="180">
                        <template #default="scope">
                            {{index +=1}}
                        </template></el-table-column>-->
                    <el-table-column prop="business" label="Nombre del CLub"> </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="Participantes" name="third">
                <div class="row">

                </div>

                <el-table :data="participantes" highlight-current-row height="500">
                    <el-table-column label="Participante" width="300">
                        <template #default="scope">
                            <div class="d-flex align-items-center">
                                <div class="symbol symbol-40 symbol-light-success mr-3">
                                    <el-avatar shape="square" size="large" fit="contain" :src="scope.row.photo" :class="'border-success'"></el-avatar>
                                </div>
                                <div class="text-dark-50 text-hover-primary" style="line-height:1.25">
                                    <span>{{scope.row.firstname}} </span><br>
                                    <span> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gender" label="Categoría" width="100px">
                    </el-table-column>
                    <el-table-column prop="modality" label="Modalidad" width="200px">
                    </el-table-column>
                    <el-table-column prop="division" label="División" width="200px">
                    </el-table-column>
                    <el-table-column prop="nfunction" label="Función" width="100px">
                        <template #default="scope">
                            <span v-if="scope.row.tregister == 'DE'" class="badge badge-success">{{scope.row.nfunction}}</span>
                            <span v-else class="badge badge-info">{{scope.row.nfunction}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="business" label="Club">
                    </el-table-column>

                </el-table>

            </el-tab-pane>
            <el-tab-pane label="Documentación" name="fourth">
                <el-table :data="documentList" highlight-current-row>
                    <el-table-column prop="name" label="Descripción"></el-table-column>
                    <el-table-column label="Opción">
                        <template #default="scope">
                            <a :href="scope.row.url" target="_blank" type="primary">Descargar</a>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="Cuadro de merito" name="five">No se tiene información por el momento</el-tab-pane>
            <el-tab-pane label="Sponsors" name="six">Este evento aún no tiene patrocinadores</el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import PublicService from "@/core/services/pbapi.service";
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
    name: "Details",
    data: () => ({
        activeName: 'first',
        documentList: [],
        clubs: [],
        index: 0,
        participantes: [],
        evento: {}
    }),
    methods: {
        handleClick() {
            //console.log('dd')
            if (this.activeName == 'fourth') {
                this.getMultimedia()
            }
            if (this.activeName == 'second') {
                this.getClubs()
            }
            if (this.activeName == 'third') {
                this.getParticipantes()
            }
        },
        async getMultimedia() {
            this.documentList = []
            // this.documentList.push({name: 'BASES GENERALES', ruta: ''}, {name: 'PROTOCOLO DE BIOSEGURIDAD', ruta: ''})
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await PublicService.getMultimedia(this.evento).then((res) => {
                this.documentList = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$message.error({
                    showClose: true,
                    message: 'Lo sentimos, se ha producido un error en la carga de información.'
                })
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        async getClubs() {
            this.clubs = []
            this.index = 0
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await PublicService.getClubsParticipantes(this.evento).then((res) => {
                this.clubs = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$message.error({
                    showClose: true,
                    message: 'Lo sentimos, se ha producido un error en la carga de información.'
                })
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        async getParticipantes() {
            this.participantes = []
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await PublicService.getParticipantes(this.evento).then((res) => {
                this.participantes = res.data
            }).catch((error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.$message.error({
                    showClose: true,
                    message: 'Lo sentimos, se ha producido un error en la carga de información.'
                })
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    },
    created() {
        this.evento = this.$route.params.id
        
        this.getMultimedia()
    }
}
</script>
